/**
 * MIME types for: JPG, PNG, WEBP, GIF, BMP, TIFF, PDF, Word (.doc, .docx), Excel (.xls, .xlsx)
 */
export const ALLOWED_UPLOAD_MIME_TYPES = [
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/webp',
  'image/gif',
  'image/bmp',
  'image/x-ms-bmp',
  'image/tiff',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
] as const

export const SUPPORT_DOC_ALLOWED_MIMES = new Set<string>(
  ALLOWED_UPLOAD_MIME_TYPES
)

export const SUPPORT_DOC_ALLOWED_EXT = new Set([
  'png',
  'jpg',
  'jpeg',
  'webp',
  'gif',
  'bmp',
  'tif',
  'tiff',
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
])

/** Shown when a file is rejected (keep in sync with allowlists above). */
export const allowedUploadFileTypesMessage =
  'Allowed: images (JPG, PNG, WEBP, GIF, BMP, TIFF), PDF, Word (.doc, .docx), Excel (.xls, .xlsx).'

/** Ant Design Upload `accept` — images, PDF, Word, Excel */
export const acceptUploadFileTypes = [
  '.png',
  '.jpeg',
  '.jpg',
  '.webp',
  '.gif',
  '.bmp',
  '.tif',
  '.tiff',
  '.pdf',
  '.xls',
  '.xlsx',
  '.doc',
  '.docx',
  '.csv',
  '.txt',
  '.rtf',
].join(', ')
